
class NavbarController {
    constructor($state, $scope, LoadedModel, $rootScope, MenuElements) {
        this._$state = $state;
        this.model = LoadedModel;
        this._$scope = $scope;
        this._$rootScope = $rootScope;
        this._menuClass = MenuElements;
        this._menuElements = MenuElements.get();

      $scope.$on('thicknessChanged', (event, data) => {
          //this._menuClass.updateActiveStates(data.step);
          setTimeout(()=> {
            $scope.$apply();
          });
      });

        ['solverFinished', 'updateSteps'].forEach((eventName) => {
            $scope.$on(eventName, (event, data) => {
                if(!data.error) {
                    this._menuClass.updateActiveStates(data.step);
                    setTimeout(()=> {
                        $scope.$apply();
                    });
                }
            });
        });
    }

    getMenuElements() {
        return this._menuElements;
    }

    isStateActive(stateName) {
        return this._$state.$current.name === stateName;
    }

    isDisabled(el) {
        const activeState = el.activeState;
        if (!activeState) {
            return false;
        } else {
            return this._menuClass.activeStates.indexOf(activeState) === -1;
        }
    }

    clearSession() {
        this.model.clearSession();
        this._menuClass.resetStates();
    }
}

NavbarController.$inject = ['$state', '$scope', 'LoadedModel', '$rootScope', 'MenuElements'];

export default NavbarController;



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.controller.js